import { render, staticRenderFns } from "./DePwd.vue?vue&type=template&id=af548af6&"
import script from "./DePwd.vue?vue&type=script&lang=js&"
export * from "./DePwd.vue?vue&type=script&lang=js&"
import style0 from "./DePwd.vue?vue&type=style&index=0&id=af548af6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports